import type { ReactNode } from 'react';

export const symbol_select_window_off: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M812-63 407-467H140v327h506v-174l60 60v114q0 24.75-17.62 42.37Q670.75-80 646-80H140q-24.75 0-42.37-17.63Q80-115.25 80-140v-387q0-24.75 17.63-42.38Q115.25-587 140-587h115v-32L47-827q-9-9.07-9-21.53Q38-861 47.05-870q9.06-9 21.5-9Q81-879 90-870l765 765q9 9 9 21t-9.05 21q-9.06 9-21.5 9Q821-54 812-63Zm68-757v387q0 24.75-17.62 42.37Q844.75-373 820-373H698q-12.44 0-23.72-5T655-391L510-536q-7-7-8-15.5t2-16.5q3-8 9.75-13.5T531-587h101q32 0 53 21t21 53v80h114v-327H311q-12.44 0-23.72-5t-19.35-13.07l-50.6-50.6Q210-836 209-844.5t2-16.5q3-8 9.75-13.5T238-880h582q24.75 0 42.38 17.62Q880-844.75 880-820Z"
		/>
	</svg>
);
